import axios from 'axios'
import React, { useEffect, useState } from 'react'
import apiClient from '../../../utils/apiclient'
import { useNavigate } from 'react-router-dom'

const normalizeTimeSlot = (value) => {
  if (!value) return '';
  const time = String(value);
  return time.length === 5 ? `${time}:00` : time.slice(0, 8);
};

const displayTimeSlot = (value) => normalizeTimeSlot(value).slice(0, 5);

const PendingOnetimeOrders = (route) => {
  const [dateMap, setDateMap] = useState({});
  const [refundMap, setRefundMap] = useState({});
  const ORDER_STATUSES = [
  "ordered",
  "delivered",
  "cancelled",
  "Refunded",
  "Rider is assigned",
  "on the way",
  "payment_initiated",
  "payment_cancelled",
  "delivered_Refunded",

];
const [data, Setdata] = useState([]);
const [page, setPage] = useState(0);
const [size] = useState(20);
const [totalPages, setTotalPages] = useState(0);
const [loading, setLoading] = useState(false);
const [freebieMap, setFreebieMap] = useState({});
const [availableAddressMap, setAvailableAddressMap] = useState({});
const [startTimeMap, setStartTimeMap] = useState({});
const [restaurantTimeSlotsMap, setRestaurantTimeSlotsMap] = useState({});
const [timeSlotLoadingMap, setTimeSlotLoadingMap] = useState({});
const [toast, setToast] = useState(null);
const handleRefundChange = (orderId, field, value) => {
  setRefundMap((prev) => ({
    ...prev,
    [orderId]: {
      ...prev[orderId],
      [field]: value,
    },
  }));
};
  console.log(route.route);
   const [search,Setsearch]=useState("")
const [statusMap, setStatusMap] = useState({});
useEffect(() => {
  fetchOrders();
}, [page,search]);

const fetchOrders = async () => {
  try {
    setLoading(true);

    const res = await apiClient.get(
  `${route.route}?page=${page}&size=${size}&search=${search}`
);

    Setdata(res.data.content);
    setTotalPages(res.data.totalPages);

    const status = {};
    const dates = {};
    const refunds = {};
    const freebies = {};
    const startTimes = {};

    res.data.content.forEach((o) => {
      status[o.id] = o.orderStatus;

      dates[o.id] = o.orderdate;

      refunds[o.id] = {
        coins: o.refundedCoins || 0,
        cash: o.refundedCash || 0,
      };
      freebies[o.id] = o.freebieDelivered ?? false;
      startTimes[o.id] = normalizeTimeSlot(o.startTime);
    });

    setStatusMap(status);
    setDateMap(dates);
    setRefundMap(refunds);
    setFreebieMap(freebies);
    setStartTimeMap(startTimes);
  } catch (e) {
    console.error(e);
  } finally {
    setLoading(false);
  }
};

const handleStartTimeFocus = async (restaurantId) => {
  if (!restaurantId || Object.prototype.hasOwnProperty.call(restaurantTimeSlotsMap, restaurantId)) {
    return;
  }

  setTimeSlotLoadingMap((prev) => ({
    ...prev,
    [restaurantId]: true,
  }));

  try {
    const response = await apiClient.get(`/get/timeslot/${restaurantId}`);
    const timeSlots = Array.isArray(response.data?.timeSlots)
      ? response.data.timeSlots.map(normalizeTimeSlot).filter(Boolean)
      : [];

    setRestaurantTimeSlotsMap((prev) => ({
      ...prev,
      [restaurantId]: timeSlots,
    }));
  } catch (e) {
    console.error(`Error fetching time slots for restaurant ${restaurantId}:`, e);
  } finally {
    setTimeSlotLoadingMap((prev) => ({
      ...prev,
      [restaurantId]: false,
    }));
  }
};

const handleStartTimeChange = async (orderId, updatedStartTime) => {
  const previousStartTime = startTimeMap[orderId] ?? '';
  const shouldUpdate = window.confirm(
    `Change one-time order start time from ${previousStartTime || 'not set'} to ${updatedStartTime}?`
  );

  if (!shouldUpdate) {
    setStartTimeMap((prev) => ({
      ...prev,
      [orderId]: previousStartTime,
    }));
    return;
  }

  setStartTimeMap((prev) => ({
    ...prev,
    [orderId]: updatedStartTime,
  }));

  try {
    await apiClient.post(`/updatetimeslot/O/${orderId}/${updatedStartTime}`);

    setToast({ message: 'One-time order time slot updated successfully.', type: 'success' });
    setTimeout(() => setToast(null), 3000);

    Setdata((prev) =>
      prev.map((order) =>
        order.id === orderId
          ? { ...order, startTime: updatedStartTime }
          : order
      )
    );
  } catch (e) {
    setStartTimeMap((prev) => ({
      ...prev,
      [orderId]: previousStartTime,
    }));
    setToast({ message: 'Failed to update one-time order time slot.', type: 'error' });
    setTimeout(() => setToast(null), 3000);
    console.error('Error updating one-time order start time:', e);
  }
};

const handleStatusChange = (orderId, newStatus) => {
  setStatusMap((prev) => ({
    ...prev,
    [orderId]: newStatus,
  }));
};
const handleSaveStatus = async (orderId) => {
  const newStatus = statusMap[orderId];

    
  try {
    const body =
      newStatus === "Refunded" || newStatus === "delivered_Refunded"
        ? {
            coins: Number(refundMap[orderId]?.coins || 0),
            cash: Number(refundMap[orderId]?.cash || 0),
          }
        : {};

    const response =  await apiClient.put(
      `/updateOrderStatus/${orderId}/${newStatus}`,
      body
    );
    
    Setdata((prev) =>
      prev.map((order) =>
        order.id === orderId
          ? { ...order, orderStatus: newStatus }
          : order
      )
    );
  } catch (e) {
    if(e.response.status === 404) {
      alert(e.response.data.message || "Order not found");
    }

    console.error(e);
  }
};

const handleFreebieChange = (orderId, value) => {
  setFreebieMap((prev) => ({
    ...prev,
    [orderId]: value === 'true',
  }));
};

const handleSaveFreebie = async (orderId) => {
  const newStatus = freebieMap[orderId] ?? false;

  try {
    await apiClient.post('/update-freebieDelivered', {
      orderType: 'O',
      id: orderId,
      status: newStatus,
    });

    Setdata((prev) =>
      prev.map((order) =>
        order.id === orderId
          ? { ...order, freebieDelivered: newStatus }
          : order
      )
    );
  } catch (e) {
    console.error(e);
  }
};

const handleGetAvailableAddress = async (orderId) => {
  try {
    const response = await apiClient.get(`/getAvailableAddress/O/${orderId}`);
    const payload = response?.data ?? [];
    const addresses = Array.isArray(payload) ? payload : [payload];

    setAvailableAddressMap((prev) => ({
      ...prev,
      [orderId]: addresses,
    }));
  } catch (e) {
    console.error('Error fetching available address:', e);
  }
};

const handleAddressSelection = async (orderId, address) => {
  if (!address) return;

  const addressId = address.id ?? address.addressId;
  if (!addressId) {
    console.error('Address ID not found in selected address');
    return;
  }

  const shouldUpdate = window.confirm('Do you want to update this order address?');
  if (!shouldUpdate) return;

  try {
    await apiClient.post(`/getAvailableAddress/O/${orderId}/${addressId}`);
    console.log('Address updated for order', orderId, 'with addressId', addressId);
  } catch (e) {
    console.error('Error updating order address:', e);
  }
};


  const navigate=useNavigate()
    
      
    const filteredData = data.filter((el) => {
    if (search.trim() === "") {
      return true; 
    }
    return (
      el.name?.toLowerCase().includes(search.toLowerCase()) || 
      el.number?.toString().includes(search) ||
      el.email?.toLowerCase().includes(search.toLowerCase())
    );
  });
    const handlechange=(e)=>{
        const value=e.target.value;
        Setsearch(value);
        console.log(value)
    }
  return (
    <div className="w-full flex-1 flex flex-col min-h-0">
      {toast && (
        <div className={`fixed top-4 right-4 z-50 rounded px-4 py-3 text-sm text-white shadow-lg ${toast.type === 'success' ? 'bg-green-600' : 'bg-red-600'}`}>
          {toast.message}
        </div>
      )}
      <div className="flex justify-between items-center mb-2 flex-shrink-0 gap-3">
        <h2 className="text-base md:text-xl font-semibold text-gray-800 whitespace-nowrap">Pending One-Time Orders</h2>
        <input className="flex-1 border-2 py-1.5 px-3 md:py-2 md:px-4 text-sm md:text-base rounded-lg outline-none focus:border-blue-500 min-w-0"
          placeholder='Search...'
          onChange={handlechange}
          value={search}
        />
      </div>

    <div className="w-full flex-1 flex flex-col min-h-0">
     {loading ? (
<div className="absolute inset-0 bg-white/60 flex justify-center items-center z-10">
      Loading...
    </div>
) : (
<div className="w-full flex-1 overflow-auto pb-4 relative">
        <table className='min-w-max w-full bg-white shadow-md border-collapse'>
      <thead className="bg-gray-800 text-white sticky top-0 z-20 shadow-md">
        <tr>
          <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">Order Id</th>
          <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">Available Address</th>
                <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">Public Id</th>

          <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">Chef Id</th>
          <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">Items</th>
          <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">startTime</th>
          <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">endTime</th>
          <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">Order Items <br/><span className='p-2'> name </span><span className='p-2'> count </span><span className='p-2'> price </span><span className='p-2'> description </span></th>

      <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">Delivery Instruction</th>

          <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">OTP</th>
      <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">Non Discounted Price</th>
      <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">Price</th>
      <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">Coins</th>
      <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">Discount Value</th>
          <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">Order Status</th>
          <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">Freebie Delivered</th>
          <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">Customer Number</th>
          <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">Customer Name</th>
          <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">Restaurant Name</th>
          <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">Order Date</th>
                <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm whitespace-nowrap">street</th>
      <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm whitespace-nowrap">city</th>
      <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm whitespace-nowrap">latitude</th>
      <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm whitespace-nowrap">longitude</th>
          <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">Rider name</th>
          <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">Rider number</th>
<th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm whitespace-nowrap">Created At</th>
          <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm whitespace-nowrap">Updated At</th>
        </tr>
      </thead>
      <tbody>
        {data.map((data, index) => {
          const currentStartTime = normalizeTimeSlot(startTimeMap[data.id] ?? data.startTime);
          const restaurantTimeSlots = restaurantTimeSlotsMap[data.restaurantid] ?? [];
          const timeSlots = currentStartTime && !restaurantTimeSlots.includes(currentStartTime)
            ? [currentStartTime, ...restaurantTimeSlots]
            : restaurantTimeSlots;

          return (
          <tr
            key={index}
            className="items-center justify-center border border-gray-300"
          >
            <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">
              {data.id}
            </td>
            <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">
              <div className="flex flex-col items-center justify-center gap-2">
                <button
                  type="button"
                  onClick={() => handleGetAvailableAddress(data.id)}
                  className="bg-blue-600 hover:bg-blue-700 text-white px-2 py-1 rounded text-[10px] md:text-xs font-medium whitespace-nowrap"
                >
                  Get Available Address
                </button>

                {availableAddressMap[data.id] && availableAddressMap[data.id].length > 0 && (
                  <select
                    className="border rounded px-1 py-0.5 text-[10px] md:text-xs max-w-[180px]"
                    defaultValue=""
                    onChange={(e) => {
                      const selectedIndex = Number(e.target.value);
                      const selectedAddress = availableAddressMap[data.id][selectedIndex];
                      handleAddressSelection(data.id, selectedAddress);
                      e.target.value = "";
                    }}
                  >
                    <option value="">Select address</option>
                    {availableAddressMap[data.id].map((address, idx) => {
                      const label = typeof address === 'string'
                        ? address
                        : `${address?.street || ''}, ${address?.city || ''}, ${address?.postalCode || ''}`.replace(/,\s*,/g, ',').replace(/^,\s*|,\s*$/g, '') || `Address ${idx + 1}`;

                      return (
                        <option key={`${data.id}-${idx}`} value={idx}>
                          {label}
                        </option>
                      );
                    })}
                  </select>
                )}
              </div>
            </td>
                    <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.publicId}</td>

            <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.chefid}</td>
           <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">
          <div className="flex flex-col items-center">
            {data.orderItems.map((orderItems, idx) => (
              <div key={idx} className="flex gap-2">
                <span>{orderItems.name}</span>x
                <span>{orderItems.count}</span>=
                <span>{orderItems.price}</span>
              </div>
            ))}
          </div>
        </td>
            <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">
              <select
                className="border rounded px-2 py-1"
                value={startTimeMap[data.id] ?? normalizeTimeSlot(data.startTime)}
                onFocus={() => handleStartTimeFocus(data.restaurantid)}
                onChange={(e) => handleStartTimeChange(data.id, e.target.value)}
              >
                <option value="" disabled>Select time</option>
                {timeSlots.map((time) => (
                  <option key={time} value={time}>
                    {displayTimeSlot(time)}
                  </option>
                ))}
                {timeSlotLoadingMap[data.restaurantid] && (
                  <option value="" disabled>Loading times...</option>
                )}
              </select>
            </td>
            <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.endTime}</td>
             <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm flex flex-col justify-center text-center items-center">{data.orderItems.map((orderItems,idx)=>(
                <tr key={idx} className='flex '><td className="px-2 md:px-5 py-2 text-[10px] md:text-sm w-20">{orderItems.name}</td>
                <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm w-20">{orderItems.count}</td>
                <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm w-16">{orderItems.price}</td>
                <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm w-16">{orderItems.description?orderItems.description:"no data"}</td></tr>
              
              ))}</td>
                    <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.deliveryInstruction?data.deliveryInstruction:"no data"}</td>

            <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.otp}</td>
<td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.nonDiscountedPrice}</td>
        <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.price}</td>
        <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.coinsused}</td>
        <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.discountvalue}</td>              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">
  <div className="flex flex-col items-center gap-2">
  <div className="flex items-center gap-2">
    <select
      className="border rounded px-2 py-1"
      value={statusMap[data.id] ?? data.orderStatus}
      onChange={(e) => handleStatusChange(data.id, e.target.value)}
    >
      {ORDER_STATUSES.map((status) => (
        <option key={status} value={status}>
          {status.replace(/_/g, " ").toUpperCase()}
        </option>
      ))}
    </select>

    {statusMap[data.id] !== data.orderStatus && (
      <button
        onClick={() => handleSaveStatus(data.id)}
        className="bg-green-600 text-white px-2 py-1 rounded text-sm"
      >
        Save
      </button>
    )}
  </div>

  {/* ✅ SHOW ONLY FOR REFUND STATUSES */}
  {(statusMap[data.id] === "Refunded" ||
    statusMap[data.id] === "delivered_Refunded") && (
    <div className="flex gap-2">
      <input
        type="number"
        placeholder="Coins"
        className="border px-2 py-1 rounded w-20"
        value={refundMap[data.id]?.coins || ""}
        onChange={(e) =>
          handleRefundChange(data.id, "coins", e.target.value)
        }
      />

      <input
        type="number"
        placeholder="Cash"
        className="border px-2 py-1 rounded w-20"
        value={refundMap[data.id]?.cash || ""}
        onChange={(e) =>
          handleRefundChange(data.id, "cash", e.target.value)
        }
      />
    </div>
  )}
</div>
</td>

            <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center whitespace-nowrap">
              <div className="flex items-center justify-center gap-2">
                <select
                  className="border rounded px-2 py-1"
                  value={String(freebieMap[data.id] ?? false)}
                  onChange={(e) => handleFreebieChange(data.id, e.target.value)}
                >
                  <option value="false">No</option>
                  <option value="true">Yes</option>
                </select>

                {String(freebieMap[data.id] ?? false) !== String(data.freebieDelivered ?? false) && (
                  <button
                    onClick={() => handleSaveFreebie(data.id)}
                    className="bg-indigo-600 hover:bg-indigo-700 text-white px-2 py-1 rounded text-sm font-medium"
                  >
                    Save Freebie
                  </button>
                )}
              </div>
            </td>

            <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center hover:text-blue-900 hover:cursor-pointer hover:underline"
              onClick={() => navigate(`/userDetails/${data.number}`)}
            >
              {data.number}
            </td>
                    <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center whitespace-nowrap">{data.userdetails?.name}</td>

            <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center hover:text-blue-900 hover:cursor-pointer hover:underline"
              onClick={() => navigate(`/restaurant/${data.restaurantid}`)}
            >
              {data.restaurantName}
            </td>
<td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">
  <div className="flex items-center justify-center gap-2">
    
   <input
  type="date"
  className="border px-2 py-1 rounded"
  value={
    dateMap[data.id]
      ? new Date(dateMap[data.id]).toISOString().split("T")[0]
      : ""
  }
  onChange={(e) => {
    setDateMap((prev) => ({
      ...prev,
      [data.id]: e.target.value,
    }));
  }}
/>


    <button
      onClick={async () => {
  try {
    const updatedDate = dateMap[data.id];

    await apiClient.put(
      `/updateOrderDate/${data.id}/${updatedDate}`
    );

    // update UI also
    Setdata((prev) =>
      prev.map((order) =>
        order.id === data.id
          ? { ...order, orderdate: updatedDate }
          : order
      )
    );

    alert("Order date updated successfully");
  } catch (e) {
    console.error(e);
  }
}}
      className="bg-green-600 text-white px-2 py-1 rounded text-sm"
    >
      Save
    </button>

  </div>
</td>
                <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center whitespace-nowrap">{data.city}</td>
        <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center whitespace-nowrap">{data.street}</td>
        <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center whitespace-nowrap">{data.latitude}</td>
        <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center whitespace-nowrap">{data.longitude}</td>
            <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.riderDetails.name}</td>
            <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.riderDetails.number}</td>
                  <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center whitespace-nowrap">{data.createdAt?data.createdAt.split("T")[1].split(".")[0]:"-"}</td>
            <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center whitespace-nowrap">{data.updatedAt?data.updatedAt.split("T")[1].split(".")[0]:"-"}</td>
          </tr>
          );
        })}
      </tbody>
    </table>
      </div>
)}
    <div className="flex justify-center items-center gap-4 mt-0 pb-4 flex-shrink-0">
        <button
          disabled={page === 0 || loading}
          onClick={() => setPage((prev) => prev - 1)}
          className="px-6 py-2 bg-gray-800 text-white font-semibold rounded disabled:opacity-50 hover:bg-gray-700 transition-colors"
        >
          Previous
        </button>

        <span className="font-medium text-gray-700">
          Page {page + 1} of {totalPages}
        </span>

        <button
          disabled={page >= totalPages - 1 || loading}
          onClick={() => setPage((prev) => prev + 1)}
          className="px-6 py-2 bg-gray-800 text-white font-semibold rounded disabled:opacity-50 hover:bg-gray-700 transition-colors"
        >
          Next
        </button>
      </div>
  </div>
</div>
)
}

export default PendingOnetimeOrders